module.exports = __webpack_public_path__ + "img/rocky.a6dc25b5.png";